import { loc } from "../../../../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js";
import "../../../../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/models/Model.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/framework/View.js";
import "../../../../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js";
import { BaseIdPAuthenticatorBody, BaseIdpAuthenticatorView } from "./BaseIdpAuthenticator.js";
import { FORMS } from "../../../ion/RemediationConstants.js";
const Body = BaseIdPAuthenticatorBody.extend({
  title: function() {
    const redirectIDVerifyRemediation = this.options.appState.get("remediations").find((remediation) => {
      return remediation.name === FORMS.REDIRECT_IDVERIFY;
    });
    return loc("oie.idv.idp.title", "login", [redirectIDVerifyRemediation.idp.name]);
  },
  subtitle: function() {
    return loc("oie.idv.idp.description", "login");
  },
  save: function() {
    return loc("oie.optional.authenticator.button.title", "login");
  }
});
var RedirectIdvView = BaseIdpAuthenticatorView.extend({
  Body
});
export { RedirectIdvView as default };
